var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.9;}.b{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.5px;}.c,.e{fill:none;}.c{stroke:#FFFFFF;stroke-width:3px;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-149 -5391)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.932,13.669a6.537,6.537,0,1,0-8.084,0,10.9,10.9,0,0,0-6.777,8.912,1.1,1.1,0,1,0,2.179.24,8.716,8.716,0,0,1,17.324,0,1.09,1.09,0,0,0,1.09.97h.12a1.09,1.09,0,0,0,.959-1.2,10.9,10.9,0,0,0-6.81-8.923ZM12.89,12.9a4.358,4.358,0,1,1,4.358-4.358A4.358,4.358,0,0,1,12.89,12.9Z",
    transform: "translate(157.964 5399.952)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(149 5391)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 22,
    cy: 22,
    r: 20.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4e2ae37e0353f1cb8f49d9436fc0d451.svg";
export { ForwardRef as ReactComponent };